import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'

import requestConfig from 'app/requests/LongTermLease/BookedContainer.requests'
import {
    DedicatedContainerType,
} from '../longTermLease.types'

const useGetDedicatedContainers = (longTermLeaseId: number) => {
    return useRequest<DedicatedContainerType[]>({
        key: RequestKeys.getDedicatedContainers,
        params: {
            longTermLeaseId,
        },
        requestFunc: RequestFn.getEntity(requestConfig.filterRequest, (promise) => {
            return promise.then((resp) => {
                return resp?.data?.items
            })
        }),
        enabled: Boolean(longTermLeaseId),
    })
}

export default useGetDedicatedContainers
